var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Grid, Stepper, Step, StepLabel } from "@mui/material";
import { FORM_STEPS } from "../../constants/forms.constants";
var FormStepper = function (_a) {
    var activeStep = _a.activeStep;
    return (_jsx(Grid, __assign({ item: true, xs: 12, sx: { mb: 4, mt: 2 } }, { children: _jsx(Stepper, __assign({ activeStep: activeStep, alternativeLabel: true }, { children: FORM_STEPS.map(function (label) { return (_jsx(Step, { children: _jsx(StepLabel, { children: label }) }, label)); }) })) })));
};
export default FormStepper;
